'use strict';
// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('TipoOcorrenciaObjectService', function(filterFilter) {
  //eslint-disable-next-line
  const getIndicador = function(indicador, nome, indice) {
    let valor = null;
    switch (indicador.numero_faixas) {
    case 3:
      if (nome === 'controle') {
        valor = indicador.faixas[1];
      }
      break;
    case 4:
    case 5:
      if (nome === 'alto_equilibrio') {
        valor = indicador.faixas[1];
      } else {
        valor = indicador.faixas[2];
      }
      break;
    default:
      valor = null;
    }
    return valor || null;
  };
  return {
    convertToSend: function(registro) {
      return {
        atividade_alvo: this.getAtividadesAlvoToSend(registro),
        ativo: registro.ativo ? 'S' : 'N',
        descricao: registro.descricao,
        id: registro.id || null,
        indicadores_attributes: this.getIndicadoresToSend(registro),
        nome_cientifico: registro.nomeCientifico,
        parte_atacada: registro.parteAtacada,
        tp_ocorrencia: registro.tipo.id,
        subtipo: (registro.classificacao || {}).id
      };
    },

    convertToObject: function(registro) {
      const temRegistro = registro && registro.id;
      const result = !temRegistro ? {} : {
        atividadesAlvo: registro.atividade_alvo,
        ativo: registro.ativo,
        descricao: registro.descricao,
        id: registro.id,
        indicadores: registro.indicadores,
        nomeCientifico: registro.nome_cientifico,
        parteAtacada: registro.parte_atacada,
        tipo: filterFilter(TIPOS_OCORRENCIA, { id: registro.tp_ocorrencia }, true)[0],
        classificacao: filterFilter(CLASSIFICACOES_INVASORA, { id: registro.subtipo }, true)[0]
      };
      return result;
    },

    getAtividadesAlvoToSend: function(registro) {
      return (_.map(registro.arrayAtividades, 'id')).toString();
    },

    getIndicadoresToSend: function(registro) {
      const indicadores = filterFilter(registro.selectIndicadores, { selected: true }, true);
      const indic = indicadores.map(function(indicador) {
        indicador.faixas = indicador.faixas || [];
        return {
          cd_indicador: indicador.id,
          equilibrio: indicador.faixas[0] || null,
          alto_equilibrio: getIndicador(indicador, 'alto_equilibrio'),
          controle: getIndicador(indicador, 'controle'),
          emergencia: indicador.faixas[3] || null,
          extremo: indicador.faixas[4] || null,
          numero_faixas: indicador.numero_faixas,
          ordem: indicador.ordem
        };
      });

      return indic;
    }
  };
});
